// extracted by mini-css-extract-plugin
export default {"container":"PdfUploadForm_container__qg3cY","form":"PdfUploadForm_form__gECjK","message":"PdfUploadForm_message__M1gXx"};